import React, {useState} from 'react';
import {withRouter} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {oneOf, bool, object} from 'prop-types';

import Logo from '../Logo';
import Burger from '../Burger';
import ChangeLanguage from '../ChangeLanguage';
import {Wrapper} from '../MainBlocks';
import Sidebar from './Sidebar';

import {TopbarSubstrate, TopbarBlock} from './Topbar.styled';

const propTypes = {
  theme: oneOf(['black', 'white']),
  fixed: bool,
  history: object,
};

const Topbar = props => {
  const {
    theme = 'white',
    fixed,
    history,
  } = props;

  const {t} = useTranslation();
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const invertTheme = theme === 'white' ? 'black' : 'white';

  return (
    <TopbarSubstrate fixed={fixed}>
      <TopbarBlock theme={theme} fixed={fixed}>
        <Wrapper>
          <Burger
            theme={invertTheme}
            onClick={() => setSidebarVisible(!sidebarVisible)}
          />
          <Logo
            fillColor={invertTheme}
            onClick={() => history.push('/')}
          />
          <Sidebar
            visible={sidebarVisible}
            hide={() => setSidebarVisible(false)}
          />
          <ChangeLanguage
            theme={invertTheme}
          />

        </Wrapper>
      </TopbarBlock>
    </TopbarSubstrate>
  );
};

Topbar.propTypes = propTypes;

export default withRouter(Topbar);
